import { useEffect, useState } from 'react';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { Chip, Card, CardContent, IconButton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import CommentSection from '../CommentSection/CommentSection';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';

export default function ArtSimTable({
  rows = [],
  loading,
  onEdit,
  onDelete,
  onCommentUpdate,
  comment, // This is the global comment
  selectedRowForComments = null,
  onRowSelect
}: {
  rows?: any[];
  loading: boolean;
  onEdit?: (row: any) => void;
  onDelete?: (row: any) => void;
  onCommentUpdate?: (comment: string) => void;
  comment: string;
  selectedRowForComments?: string | null;
  onRowSelect?: (rowId: string | null) => void;
}) {
  // const [selectedRowId, setSelectedRowId] = useState<string | null>(
  //   selectedRowForComments
  // );

  const [cancelRowId, setCancelRowId] = useState<string | null>(null);
  console.log('selectedRowForComments', rows);
  const CustomChip = styled(Chip)(({ theme }) => ({
    borderRadius: '4px',
    fontFamily: 'Open Sans',
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    width: 100,
    height: '24px'
  }));
  useEffect(() => {
    // setSelectedRowId(selectedRowForComments);
  }, [selectedRowForComments]);

  const handleRowClick = (rowId: string) => {
    // setSelectedRowId(rowId);
    if (onRowSelect) onRowSelect(rowId);
  };

  // Forward the clicked row to the parent edit handler
  const handleEdit = (row: any) => {
    if (onEdit) onEdit(row);
    setCancelRowId(row.id);
  };

  //cancel edit
  const CancelhandleEdit = (row: any) => {
    if (onEdit) onEdit({});
    setCancelRowId(null);
  };
  // Handle comment updates for the selected row
  const handleCommentChange = (comment: string) => {
    onCommentUpdate?.(comment); // Just pass the comment
  };

  const handleDelete = (row: any) => {
    if (onDelete) onDelete({ ...row, delete: true });
    setCancelRowId(null);
  };

  //to get the color

  const getPriorityColor = (priority: string, type: string) => {
    console.log('priority', type);
    if (type === 'Avoid') {
      console.log('priority', priority);
      return {
        backgroundColor: '#DB2626', // Red
        color: 'white'
      };
    }
    switch (priority) {
      case '1st Request':
        return {
          backgroundColor: '#0B7507', // Green
          color: 'white'
        };
      case '2nd Request':
        return {
          backgroundColor: '#0B7507',
          color: 'white'
        };
      case '3rd Request':
        return {
          backgroundColor: '#0B7507',
          color: 'white'
        };
      case 'N/A':
        return {
          backgroundColor: '#DB2626', // Red
          color: 'white'
        };
      default:
        return {
          backgroundColor: '#0B7507', // Gray
          color: 'white'
        };
    }
  };

  // Get the selected row data
  // const selectedRow = selectedRowId
  //   ? rows.find((row) => row.id === selectedRowId)
  //   : null;

  const columns: GridColDef[] = [
    { field: 'year', headerName: 'Year', width: 100 },
    {
      field: 'date',
      headerName: 'Date',
      width: 200,
      valueGetter: (params) => {
        // params.row.dateLabel ?? params.row.date
        const range = params.row?.payload?.range;
        if (range?.startDate) {
          const start = dayjs(range.startDate);
          const end = range.endDate ? dayjs(range.endDate) : null;

          if (!end) return start.format('MMM D');

          if (start.month() === end.month() && start.year() === end.year()) {
            // if (params.row?.payload?.type === 'Plan') {
            //   return `${start.format('MMMM D')}`;
            // }
            if (start.date() === end.date()) {
              return `${start.format('MMMM D')}`;
            }
            return `${start.format('MMMM D')}-${end.format('D')}`;
          }

          return `${start.format('MMM D')} - ${end.format('MMM D')}`;
        }
      }
    },
    { field: 'session', headerName: 'Session', width: 200 },
    {
      field: 'type',
      headerName: 'Type',
      width: 160,
      renderCell: (params) => {
        const type = params.row?.payload?.type || '';
        const raw = params.row?.payload?.priority || '';
        console.log('type', type, raw);
        const displayLabel = type === 'Avoid' ? 'Avoid' : 'Planned';
        return (
          <CustomChip
            label={displayLabel.toUpperCase()}
            size="small"
            sx={{
              ...getPriorityColor(raw, type),
              fontFamily: 'Open Sans',
              fontSize: '10px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
              width: 100,
              textTransform: 'uppercase'
            }}
          />
        );
      }
    },
    {
      field: 'priority',
      headerName: 'Priority',
      width: 160,
      renderCell: (params) => {
        const type = params.row?.status || '';
        return type;
      }
    },
    {
      field: 'actions',
      headerName: '',
      width: 400,
      headerAlign: 'right',
      align: 'right',
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
        >
          {cancelRowId !== params.row.id && (
            <IconButton
              size="medium"
              aria-label="edit"
              onClick={() => handleEdit(params.row)}
              style={{
                display: 'flex',
                flexDirection: 'row',
                color: '#005078'
              }}
            >
              <EditOutlinedIcon fontSize="medium" />
              <p>Edit</p>
            </IconButton>
          )}
          {cancelRowId === params.row.id && (
            <IconButton
              size="medium"
              aria-label="edit"
              onClick={() => CancelhandleEdit(params.row)}
              style={{
                display: 'flex',
                flexDirection: 'row',
                color: '#005078'
              }}
            >
              <CancelIcon
                fontSize="medium"
                style={{ color: '#DB2626', marginLeft: '10px' }}
              />
              <p>Cancel</p>
            </IconButton>
          )}
          <IconButton
            size="medium"
            aria-label="delete"
            onClick={() => handleDelete(params.row)}
            style={{ display: 'flex', flexDirection: 'row', color: '#005078' }}
          >
            <p>Delete</p>
          </IconButton>
        </div>
      )
    }
  ];

  return (
    <Card className="art-requests-table-cntr">
      <CardContent>
        <DataGridPro
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 5, page: 0 }
            }
          }}
          pageSizeOptions={[5, 10, 20]}
          autoHeight
          onRowClick={(params) => handleRowClick(params.row.id)}
          sx={{
            marginTop: '20px',
            width: '100%',
            '& .MuiDataGrid-row': {
              cursor: 'pointer'
            },
            '& .MuiDataGrid-row.Mui-selected': {
              backgroundColor: '#e3f2fd'
            }
          }}
          hideFooterRowCount
        />

        {/* Global comment section for the entire submission */}
        {rows.length > 0 && (
          <div style={{ marginTop: '20px' }}>
            <>
              <p
                style={{
                  margin: '3px',
                  fontSize: '14px',
                  fontFamily: 'Open Sans',
                  fontWeight: 600
                }}
              >
                Special Request
              </p>
              <CommentSection
                key="global-comment" // Fixed key since it's global
                initialValue={comment} // Use the global comment
                maxChars={130}
                onChange={handleCommentChange}
              />
            </>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
